// extracted by mini-css-extract-plugin
export default {"noWrap":"n5ccJ","propertyRow":"Uyhd9","property":"oy2V9"};